import { render, staticRenderFns } from "./domicilios.vue?vue&type=template&id=a1b0bb0a"
import script from "./domicilios.vue?vue&type=script&lang=js"
export * from "./domicilios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports